import { defineStore } from 'pinia';
import type { FavoriteMenu } from "@/types/property-manager/prop-000";

export const useFavouriteStore = defineStore('favourite', {
  state: () => ({
    favourite_list: [] as FavoriteMenu[],
  }),
  actions: {
    setter(favourite_list: FavoriteMenu[] | undefined) {
      if (favourite_list) this.favourite_list = favourite_list;
    },
  },
});